module.exports = __webpack_public_path__ + "static/images/group-btn-r.eef375e.png";